var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4025_1922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0284 13.8661H10.8136V10.771H14.0284V8.19169H17.8862V10.771H21.101V13.8661H17.8862V16.4454H14.0284V13.8661ZM15.9573 2.5173L5.66992 5.61243V11.8955C5.66992 17.1056 10.0549 21.965 15.9573 23.1514C21.8596 21.965 26.2446 17.1056 26.2446 11.8955V5.61243L15.9573 2.5173ZM23.6728 11.8955C23.6728 16.0224 20.3937 19.8397 15.9573 21.0055C11.5209 19.8397 8.24176 16.0327 8.24176 11.8955V7.0465L15.9573 4.72516L23.6728 7.0465V11.8955Z",
    fill: "#CC9A18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4025_1922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.4904,
    height: 24.6463,
    fill: "white",
    transform: "translate(0.754883 0.46344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCost);
export default __webpack_public_path__ + "static/media/totalCost.e37a90f8c61cc99d66964f805278518b.svg";
export { ForwardRef as ReactComponent };